import { BasketDiscountWriteCampaignProps } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { transformCommonFormFieldsToApi } from './transformCommonFormFieldsToApi';
import { API_UNLIMITED_MAX_DELIVERY_DISTANCE } from '../../components/budget-section/constants';
import { BasketDiscountFormValues } from '../../types';

export type TransformBasketDiscountFormToApiValues = BasketDiscountFormValues & {
  currency: Currency;
  merchantId: string;
  venueIds: string[];
};

export const transformBasketDiscountFormToApi = (
  values: TransformBasketDiscountFormToApiValues,
): BasketDiscountWriteCampaignProps => ({
  ...transformCommonFormFieldsToApi(values),
  maxDeliveryDistance: API_UNLIMITED_MAX_DELIVERY_DISTANCE,
  campaignType: CampaignType.BASKET_DISCOUNT,
  basketDiscount: values.discountValue,
});
